import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Button,
  Input,
  Popover,
  PopoverBody,
  FormText,
  Spinner,
} from "reactstrap";
import moment from "moment";
import Select from "react-select";
import Datetime from "react-datetime";
import axios from "axios";
import FileSaver from "file-saver";
import { handleErrors } from "../../../../utils";
import { formatSizeUnits, getMomentLocaleByLang } from "../../../../utils/utils";

const INTERVALTIME = 5000;

class RunTestReport extends React.Component {
  state = {
    modal: false,
    loading: false,
    showPeriod: false,
    showFile: false,
    showFinalizedChannel: false,
    showBatchID: false,
    periodStart: "",
    periodEnd: "",
    fileId: "",
    fileNameShort: "",
    fileNameLong: "",
    channel: "",
    logLevel: "Info",
    batchId: "",
    reportDelivery: false,
    pipelineId: "",
    fileSearchOpen: false,
    fileIdValid: false,
    filteredFilesLoaded: false,
    reportState: "",
    report: null,
    gettingReportSpinner: false,
  };

  componentDidMount() {
    this.initialState = JSON.parse(JSON.stringify(this.state));
  }

  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
  }

  toggleModal(modal) {
    if (this.state[modal]) {
      if (this.interval) clearInterval(this.interval);
      this.setState({ gettingReportSpinner: false });
    }
    this.setState((state) => {
      return {
        [modal]: !state[modal],
        filteredFilesLoaded: false,
      };
    });
  }

  onValueChange = (e) => {
    const { id, value, type, checked } = e.target;
    const valueToUpdate = type === "checkbox" ? checked : value;
    this.setStateWrapper(id, valueToUpdate);
  };

  setStateWrapper(id, value) {
    this.setState({
      [id]: value,
    });
  }

  getReportDescriptions() {
    const { config, reportPipelineDefinitionId } = this.props;
    var reportDescriptions = config.reportsDescriptions || [];
    var reportDescription = reportDescriptions.find((obj) => {
      return obj.reporttemplatename === reportPipelineDefinitionId;
    });

    if (reportDescription) {
      var runModeParameters = reportDescription.runModeParameters;

      var runModeParameterNames = [
        "Period",
        "File",
        "FinalizedChannel",
        "BatchID",
      ];

      runModeParameterNames.forEach((parameterName) => {
        this.setState({
          ["show" + parameterName]: runModeParameters.some(
            (k) => k.paramName.toLowerCase() === parameterName.toLowerCase()
          ),
        });
      });
    }
  }

  handleRunTestReportClick = () => {
    this.setState(this.initialState, () => {
      this.setState({ channel: this.props.channel });
      this.getReportDescriptions();
      this.toggleModal("modal");
    });
  };

  handleRunReportClick = () => {
    this.setState({ loading: true });
    const PeriodStart =
      this.state.periodStart &&
      moment.utc(this.state.periodStart).format("YYYY-MM-DDTHH:mm:ss.SSS");
    const PeriodEnd =
      this.state.periodEnd &&
      moment.utc(this.state.periodEnd).format("YYYY-MM-DDTHH:mm:ss.SSS");
    let params = {
      ReportDefinitionId: this.props.reportDefinitionId,
      PeriodStart,
      PeriodEnd,
      FileId: this.state.fileId,
      FileNameShort: this.state.fileNameShort,
      FileNameLong: this.state.fileNameLong,
      Channel: this.state.channel,
      LogLevel: this.state.logLevel,
      BatchId: this.state.batchId,
      ReportDelivery: this.state.reportDelivery,
      Timezone: this.props.timezone,
    };
    if (this.interval) clearInterval(this.interval);
    this.setState({ report: null });
    axios
      .post("Reporting/Pipelines/RunTestReport", params)
      .then((response) => response.data)
      .then((response) => {
        this.setState({ loading: false });
        if (response.Errors && response.Errors.length) {
          //console.log('Errors: ' + JSON.stringify(response.Errors));
          handleErrors(
            response.Errors[0],
            this.props.dispatch,
            "Testing Report"
          );
        } else {
          this.setState({ pipelineId: response.Data.pipelineid });
          var me = this;
          this.setState({ gettingReportSpinner: true });
          this.getFullReport(response.Data);
          this.iterationCount = 0;
          this.interval = setInterval(function () {
            me.iterationCount++;
            me.getFullReport(response.Data);
          }, INTERVALTIME);
        }
      });
  };
  iterationCount = 0;
  getFullReport = async ({ _id: reportId, pipelineid }) => {
    const { dispatch, translate, isExternalUser } = this.props;
    try {
      const params = { reportinstanceobjectid: reportId };
      const response = await axios.get("Reporting/reportstatebyobjectid", {
        params: params,
      });
      if (response.data.Errors && response.data.Errors.length > 0) {
        handleErrors(response.data.Errors[0], dispatch, "Fetching Report");
      }
      if (response.data.Data) {
        const { reportState } = response.data.Data;
        this.setState({ reportState });
        if (reportState === "finished") {
          if (this.interval) clearInterval(this.interval);
          this.setState({ gettingReportSpinner: false });
          const params = {
            SearchText: pipelineid,
            PageNumber: 1,
            IsPlatformSpecific: false,
            Size: 50,
          };
          const response = await axios.get("Reporting/reports", {
            params: params,
          });
          if (response.data.Errors && response.data.Errors.length > 0) {
            handleErrors(response.data.Errors[0], dispatch, "Fetching Report");
          }
          if (response.data.Data && response.data.Data.length > 0) {
            const report = response.data.Data[0];
            this.setState({ report });
          }
        } else if (reportState === "failed") {
          if (this.interval) clearInterval(this.interval);
          this.setState({ gettingReportSpinner: false });
          handleErrors(
            translate(
              isExternalUser
                ? "FailedReportMsg"
                : "FileGenerationFailedMsg"
            ),
            dispatch,
            "Fetching Report"
          );
        } else if (this.iterationCount > 4 && isExternalUser) {
          if (this.interval) clearInterval(this.interval);
          this.setState({ gettingReportSpinner: false });
          handleErrors(
            translate("LongPendingReportMsg"),
            dispatch,
            "Fetching Report"
          );
        }
      } else {
        handleErrors("No report found", dispatch, "Fetching Report");
      }
    } catch (error) {
      handleErrors(error, dispatch, "Fetching Report");
    }
  };

  handleViewPipelineClick = () => {
    this.toggleModal("modal");
    this.props.closeParentModal();
    var qs = require("qs");
    var pipelineId = this.state.pipelineId;
    var qData = {
      search: pipelineId,
    };
    this.props.history.push("/exec-reports?" + qs.stringify(qData));
  };

  onFileFilterValueChange = (e) => {
    const { id, value } = e.target;
    const { customerId, channel, project, projects } = this.props;
    this.setStateWrapper(id, value);
    this.setState({ fileIdValid: false });
    var _from = moment.utc()
      .subtract(6, "month")
      .add(1, "day")
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toDate();
    var _to = moment.utc()
      .set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
      .toDate();
    let params = {
      CustomerId: customerId,
      ChannelName: channel,
      IsPlatformSpecific: false,
      StatusFilter: ["Delivered", "InProgress"],
      Start: moment.utc(_from).format("YYYY-MM-DDTHH:mm:ss.SSS"),
      End: moment.utc(_to).format("YYYY-MM-DDTHH:mm:ss.SSS"),
      PageNumber: 1,
      Size: 5,
      SlaFilter: ["ok", "breached", "breachwarning", "calcfailed"],
    };
    if (project) {
      params["ProjectId"] = this.props.project;
    } else if (projects && projects.length) {
      params["ProjectIds"] = this.props.projects;
    }
    if (value.toString().trim()) {
      params["FileNames"] = value.toString().trim();
    }
    this.setState({
      fileSearchOpen: true,
      filteredFilesLoaded: false,
    });
    var qs = require("qs");
    axios
      .get("Tracking/FileListFromBucket", {
        params: params,
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      })
      .then((response) => response.data)
      .then((response) => {
        if (response.Errors && response.Errors.length > 0) {
          this.setState({
            filteredFilesLoaded: true,
            filteredFiles: [],
          });
        } else if (response.Data.length === 1) {
          this.handleFilteredFileRowClick(response.Data[0]);
        } else {
          this.setState({
            filteredFilesLoaded: true,
            filteredFiles: response.Data,
          });

          if (response.Data.length === 1) {
            this.handleFilteredFileRowClick(response.Data[0]);
          }
        }
      });
  };

  getFileResult = () => {
    const { filteredFiles, filteredFilesLoaded } = this.state;
    const { isExternalUser, translate } = this.props;
    if (!filteredFilesLoaded) {
      return <p>{translate("Loading")}</p>;
    }
    if (filteredFiles && filteredFiles.length) {
      return (
        <table
          className="table-bordered table-condensed cf table-hover table-sm panel-default col-12 col-lg-offset-0 card-list-table"
          cellSpacing="0"
          style={{ border: "0px", padding: "0px" }}
        >
          <tbody style={{ backgroundColor: "#fff", fontSize: "12px" }}>
            {filteredFiles.map((file, index) => (
              <tr
                key={index}
                className={
                  "row_tr finger w_p_action row-status-" +
                  file.status.id +
                  (file.mode === "test" ? " mode_color" : "") +
                  (file.isActive ? " active-row" : "") +
                  (file.expanded ? " expanded" : "")
                }
                dataaction="open_sub_table_files"
                dataactionid={index}
                onClick={(e) => {
                  this.handleFilteredFileRowClick(file);
                }}
              >
                <td className="file-flow-column">
                  <div
                    className={
                      !isExternalUser
                        ? "w_p_action underline finger w_p_action_tooltip"
                        : "w_p_action external_hide_link"
                    }
                    data-action=""
                    title={
                      !isExternalUser
                        ? `Open flow - File name: ${file.file.shortname}`
                        : ""
                    }
                  >
                    <div data-action="">
                      <b data-action="">{file.file.shortname}</b>
                      {!isExternalUser && (
                        <span
                          data-action=""
                          style={{ marginLeft: "5px", fontSize: "0.8em" }}
                        >
                          {"(" + formatSizeUnits(file.file.size) + ")"}
                        </span>
                      )}
                    </div>
                  </div>
                </td>
                <td
                  data-title="Flow/Project"
                  className="file-proj-column text-center"
                >
                  <span>{file.flow}</span>
                </td>
                <td style={{ width: "180px" }}>
                  <div
                    style={{
                      textTransform: "uppercase",
                      float: "left",
                      textAlign: "center",
                      marginLeft: "1.5em",
                    }}
                    data-tip
                    data-place="bottom"
                    data-type="info"
                    data-effect="solid"
                    data-for={`FileStatusTip-${file.id}`}
                    className={"tag-status-label status-" + file.status.id}
                  >
                    {translate(file.status.id)}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    } else {
      return <p>{translate("NoResults")}</p>;
    }
  };

  handleFilteredFileRowClick = (file) => {
    this.setState({
      fileId: file.file.eventid,
      fileNameShort: file.file.shortname,
      fileNameLong: file.file.longname,
      fileIdValid: true,
      fileSearchOpen: false,
    });
  };

  getSmtpTransport = (transportItems) => {
    const { translate } = this.props;
    return transportItems
      .filter((item) => item.type === "Smtp")
      .map((item, index) => {
        return [
          <td
            key={"header-" + index}
            className="additional-info-header"
            style={{ padding: "0" }}
          >
            <div>
              <span>{translate("Email")}</span>
            </div>
          </td>,
          <td key={index} className="additional-info-content">
            <div className="transport-content">
              <div>
                <div>
                  <strong>{translate("from")}: </strong>
                  <span>
                    {item.from &&
                      item.from.split(";").map((item, key) => {
                        return (
                          <span key={key}>
                            {item}
                            <br />
                          </span>
                        );
                      })}
                  </span>
                </div>
                {item.To && (
                  <div>
                    <strong>{translate("to")}: </strong>
                    <span>
                      {item.To &&
                        item.To.split(";").map((item, key) => {
                          return (
                            <span key={key}>
                              {item}
                              <br />
                            </span>
                          );
                        })}
                    </span>
                  </div>
                )}
                {item.cc && (
                  <div>
                    <strong>cc: </strong>
                    <span>
                      {item.cc &&
                        item.cc.split(";").map((item, key) => {
                          return (
                            <span key={key}>
                              {item}
                              <br />
                            </span>
                          );
                        })}
                    </span>
                  </div>
                )}
                {item.bcc && (
                  <div>
                    <strong>bcc: </strong>
                    <span>
                      {item.bcc &&
                        item.bcc.split(";").map((item, key) => {
                          return (
                            <span key={key}>
                              {item}
                              <br />
                            </span>
                          );
                        })}
                    </span>
                  </div>
                )}
              </div>
              <div className="transport-status-content">
                <div
                  className={
                    "transport-status-inner text-center report-status-" +
                    (item.state && item.state.toLowerCase())
                  }
                >
                  {translate(item.state.toLowerCase())}
                </div>
              </div>
            </div>
          </td>,
        ];
      });
  };

  stagesList = (items, pipelineId) => {
    const { translate } = this.props;
    let _resList = [];
    (items || []).forEach((item, index) => {
      if (item.type === "transport") {
        var smtpRows =
          item.additionalInfo &&
          item.additionalInfo.transportItems &&
          this.getSmtpTransport(item.additionalInfo.transportItems);

        if (smtpRows && smtpRows.length) {
          _resList.push(
            <tr key={index}>
              {smtpRows}
              <td
                rowSpan={`${smtpRows && smtpRows.length}`}
                className="text-center"
              >
                {item.state && (
                  <div
                    style={{
                      textTransform: "uppercase",
                      display: "inline-block",
                    }}
                    className={"report-status-" + item.state.st}
                  >
                    {translate(item.state.st.toLowerCase())}
                  </div>
                )}
              </td>
            </tr>
          );
        }
        var ftpRows =
          item.additionalInfo &&
          item.additionalInfo.transportItems &&
          this.getSftpTransport(item.additionalInfo.transportItems);
        if (ftpRows && ftpRows.length) {
          _resList.push(
            <tr key={index}>
              {ftpRows}
              <td
                rowSpan={`${ftpRows && ftpRows.length}`}
                className="text-center"
              >
                {item.state && (
                  <div
                    style={{
                      textTransform: "uppercase",
                      display: "inline-block",
                    }}
                    className={"report-status-" + item.state.st}
                  >
                    {translate(item.state.st.toLowerCase())}
                  </div>
                )}
              </td>
            </tr>
          );
        }
      } else {
        _resList.push(
          <tr key={index}>
            <td className="additional-info-header" style={{ padding: "0" }}>
              <div>
                <span>{translate("Script")}</span>
              </div>
            </td>
            <td className="additional-info-content">
              {this.getAdditionalInfo(
                item.type,
                item.additionalInfo,
                pipelineId
              )}
            </td>
            <td className="text-center">
              {item.state && (
                <div
                  style={{
                    textTransform: "uppercase",
                    display: "inline-block",
                  }}
                  className={"report-status-" + item.state.st}
                >
                  {translate(item.state.st.toLowerCase())}
                </div>
              )}
            </td>
          </tr>
        );
      }
    });
    return _resList;
  };

  getAdditionalInfo = (type, additionalInfo, pipelineId) => {
    const { translate, isSubUser } = this.props;
    if (type === "exec") {
      return (
        <div>
          <div>
            <strong>{translate("Documents included")}: </strong>
            <span>{additionalInfo.docCount}</span>
          </div>
          <div>
            <strong>{translate("Generated files")}: </strong>
            <div>
              {additionalInfo.generatedFiles &&
                additionalInfo.generatedFiles.length &&
                additionalInfo.generatedFiles.map((path, key) => {
                  return (
                    <span key={key}>
                      {this.getFileNameFromPath(path, pipelineId)}
                      <br />
                    </span>
                  );
                })}
            </div>
          </div>
          {!isSubUser && (
            <div>
              <strong>{translate("Logfile")}: </strong>
              <span>
                {this.getFileNameFromPath(additionalInfo.logFile, pipelineId)}
              </span>
            </div>
          )}
        </div>
      );
    }
  };

  handleDownloadableFile = (fullPath, pipelineId, fileName) => {
    var params = {
      PipelineId: pipelineId,
      FileLocation: fullPath,
    };
    this.setState({
      loadingFile: true,
    });
    axios
      .get("Reporting/Pipelines/DownloadFileDirectly", {
        params: params,
        responseType: "blob",
      })
      .then((response) => {
        var data = new Blob([response.data]);
        FileSaver.saveAs(data, fileName);
        this.setState({
          loadingFile: false,
        });
      });
  };

  getFileNameFromPath = (fullPath, pipelineId) => {
    var fileName = fullPath.replace(/^.*[\\\/]/, "");
    return (
      <button
        className="default-button-link"
        onClick={(e) => {
          this.handleDownloadableFile(fullPath, pipelineId, fileName);
        }}
      >
        {fileName}
      </button>
    );
  };

  getSftpTransport = (transportItems) => {
    const { translate } = this.props;
    return transportItems
      .filter((item) => item.type === "Sftp" || item.type === "Ftp")
      .map((item, index) => {
        return [
          <td
            key={"header-ftp-" + index}
            className="additional-info-header"
            style={{ padding: "0" }}
          >
            <div>
              <span style={{ padding: "5px 0" }}>FTP/SFTP</span>
            </div>
          </td>,
          <td key={"ftp-" + index} className="additional-info-content">
            <div className="transport-content">
              <div>
                <div>{translate("File/Files uploaded to")}:</div>
                <div>
                  <strong>{translate("Server")}: </strong>
                  <span>{item.server}</span>
                </div>
                {item.directory && (
                  <div>
                    <strong>{translate("Folder")}: </strong>
                    <span>{item.directory}</span>
                  </div>
                )}
                {item.userName && (
                  <div>
                    <strong>{translate("Username")}: </strong>
                    <span>{item.userName}</span>
                  </div>
                )}
                <div>
                  <strong>{translate("Password")}: </strong>
                  <span>********</span>
                </div>
              </div>
              <div className="transport-status-content">
                <div
                  className={
                    "transport-status-inner text-center report-status-" +
                    (item.state && item.state.toLowerCase())
                  }
                >
                  {translate(item.state.toLowerCase())}
                </div>
              </div>
            </div>
          </td>,
        ];
      });
  };

  render() {
    const {
      config,
      timezone,
      settings,
      translate,
      isSubUser,
      disabled,
      isExternalUser,
      reportDefinitionId,
    } = this.props;
    let _timezone = timezone;
    let _language = 'en-GB';
    if (!_timezone) {
      const { user, subUser } = this.props;
      let currentUser = user;
      if (isSubUser) {
        currentUser = subUser;
      }
      _timezone = currentUser.timeZone;
      _language = currentUser.language;
    }
    let _timezoneDisplayText = "";
    if (_timezone) {
      _timezoneDisplayText = (settings.availableTimeZones || []).filter(
        (item) => item.id === _timezone
      )[0]?.displayName;
    }
    let channelOptions = (config.channels || []).map((item) => {
      return { value: item, label: item };
    });
    const logLevelOptions = [
      { value: "Info", label: "Info" },
      { value: "Debug", label: "Debug" },
      { value: "Verbose", label: "Verbose" },
    ];
    return (
      <>
        <button
          type="button"
          disabled={disabled || !reportDefinitionId}
          className="btn btn-primary"
          style={{ marginLeft: "15px" }}
          onClick={this.handleRunTestReportClick}
        >
          {translate("Test")}
        </button>
        <Modal
          isOpen={this.state.modal}
          toggle={() => this.toggleModal("modal")}
          style={{ minWidth: this.state.pipelineId ? "1100px" : "550px" }}
        >
          <ModalHeader toggle={() => this.toggleModal("modal")}>
            {translate("Enter report run parameters")}
          </ModalHeader>
          <ModalBody>
            <div className={!this.state.pipelineId ? "" : "row"}>
              <div className={!this.state.pipelineId ? "" : "col-sm-6"}>
                <div
                  style={{
                    display: "grid",
                    gridRowGap: "15px",
                  }}
                >
                  {this.state.showPeriod && (
                    <>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                          }}
                        >
                          <Label for="periodStart">Period start</Label>
                          <div className="datetime-filter">
                            <Datetime
                              value={this.state.periodStart}
                              utc={true}
                              locale={getMomentLocaleByLang(_language)}
                              dateFormat="DD-MM-YYYY"
                              timeFormat="HH:mm"
                              inputProps={{
                                placeholder: "dd-MM-yyyy HH:mm",
                                className: "--date-picker-custom form-control",
                              }}
                              onChange={(Start) => {
                                const _date = moment(Start).toDate();
                                this.setStateWrapper("periodStart", _date);
                              }}
                            />
                            {/* <DatePicker
                              selected={this.state.periodStart}
                              className="--date-picker-custom form-control"
                              placeholderText="dd-MM-yyyy HH:mm"
                              onChange={(date) =>
                                this.setStateWrapper("periodStart", date)
                              }
                              dateFormat="dd-MM-yyyy HH:mm"
                              showTimeSelect
                              timeFormat="p"
                              timeIntervals={15}
                            /> */}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginLeft: "20px",
                            flex: 1,
                          }}
                        >
                          <Label for="periodEnd">Period end</Label>
                          <div className="datetime-filter">
                          <Datetime
                              value={this.state.periodEnd}
                              utc={true}
                              locale={getMomentLocaleByLang(_language)}
                              dateFormat="DD-MM-YYYY"
                              timeFormat="HH:mm"
                              inputProps={{
                                placeholder: "dd-MM-yyyy HH:mm",
                                className: "--date-picker-custom form-control",
                              }}
                              onChange={(Start) => {
                                const _date = moment(Start).toDate();
                                this.setStateWrapper("periodEnd", _date);
                              }}
                            />
                            {/* <DatePicker
                              selected={this.state.periodEnd}
                              className="--date-picker-custom form-control"
                              placeholderText="dd-MM-yyyy HH:mm"
                              popperPlacement="bottom-end"
                              onChange={(date) => {
                                this.setStateWrapper("periodEnd", date);
                              }}
                              dateFormat="dd-MM-yyyy HH:mm"
                              showTimeSelect
                              timeFormat="p"
                              timeIntervals={15}
                              injectTimes={[
                                setHours(setMinutes(new Date(), 59), 23),
                              ]}
                            /> */}
                          </div>
                        </div>
                      </div>
                      <div>
                        <Label style={{ marginRight: "0.5rem" }}>
                          {translate("Timezone used")}:{" "}
                        </Label>
                        <FormText
                          color="muted"
                          style={{ display: "inline-block" }}
                        >
                          {_timezoneDisplayText}
                        </FormText>
                      </div>
                    </>
                  )}
                  {this.state.showFile && (
                    <div>
                      <Label for="fileNameShort">
                        {" "}
                        {translate("FileName")}
                      </Label>
                      <Input
                        type="text"
                        id="fileNameShort"
                        placeholder={translate("FileName")}
                        valid={this.state.fileIdValid}
                        value={this.state.fileNameShort}
                        onChange={this.onFileFilterValueChange}
                        onBlur={() => {
                          setTimeout(() => {
                            this.setState({ fileSearchOpen: false });
                          }, 500);
                        }}
                        onFocus={(e) => {
                          if (this.state.filteredFilesLoaded) {
                            this.setState({ fileSearchOpen: true });
                          } else {
                            this.onFileFilterValueChange(e);
                          }
                        }}
                      />
                      <Popover
                        className="fileFilterPopover"
                        placement="bottom-start"
                        flip={false}
                        hideArrow={true}
                        isOpen={this.state.fileSearchOpen}
                        target="fileNameShort"
                        toggle={this.toggle}
                      >
                        <PopoverBody>{this.getFileResult()}</PopoverBody>
                      </Popover>
                    </div>
                  )}
                  {this.state.showFinalizedChannel && (
                    <div>
                      <Label>{translate("Channel")}</Label>
                      <Select
                        id="channel"
                        value={this.state.channel}
                        placeholder={translate("Channel")}
                        disabled={!!this.props.channel}
                        onChange={(channel) =>
                          this.setStateWrapper(
                            "channel",
                            channel ? channel.value : null
                          )
                        }
                        options={channelOptions}
                      />
                    </div>
                  )}
                  {this.state.showBatchID && (
                    <div>
                      <Label for="batchId"> {translate("BatchId")}</Label>
                      <Input
                        type="text"
                        id="batchId"
                        value={this.state.batchId}
                        onChange={this.onValueChange}
                        placeholder="BatchId"
                      />
                    </div>
                  )}
                  {!isSubUser && (
                    <div>
                      <Label>{translate("Log level")}</Label>
                      <Select
                        clearable={false}
                        name="logLevel"
                        value={this.state.logLevel}
                        placeholder="Log level"
                        onChange={(logLevel) =>
                          this.setStateWrapper(
                            "logLevel",
                            logLevel ? logLevel.value : null
                          )
                        }
                        options={logLevelOptions}
                      />
                    </div>
                  )}
                  <div>
                    <Input
                      type="checkbox"
                      id="reportDelivery"
                      checked={this.state.reportDelivery}
                      onChange={this.onValueChange}
                      style={{ position: "relative", margin: "0 7px 0 0" }}
                    />
                    {translate("Enable report delivery")}
                  </div>
                </div>
              </div>
              {!!this.state.pipelineId && (
                <div className="col-sm-6">
                  <div>
                    <div>
                      <strong>Execution panel:</strong>
                    </div>
                    {!isExternalUser && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          Pipeline ID: {this.state.pipelineId}
                        </div>
                        {this.state.reportState === "finished" && (
                          <div>
                            <Button
                              color="primary"
                              disabled={this.state.loading}
                              onClick={this.handleViewPipelineClick}
                            >
                              {translate("ViewPipeline")}
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                    {this.state.reportState && (
                      <div>
                        <span>Status: </span>
                        {this.state.reportState && (
                          <div
                            style={{
                              textTransform: "uppercase",
                              display: "inline-block",
                              textAlign: "center",
                            }}
                            className={
                              "report-status-" + this.state.reportState
                            }
                          >
                            {translate(this.state.reportState.toLowerCase())}
                          </div>
                        )}
                        {this.state.gettingReportSpinner && (
                          <Spinner
                            color="info"
                            size="sm"
                            style={{ margin: "0 0.5em" }}
                          />
                        )}
                      </div>
                    )}
                    {this.state.report && (
                      <div>
                        <table
                          className="table-bordered table-condensed table-hover table-sm panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12 col-lg-offset-0"
                          cellSpacing="0"
                          style={{ border: "0px", padding: "10px" }}
                        >
                          <colgroup>
                            <col width="27" />
                            <col width="1*" />
                            <col width="140" />
                            <col width="100" />
                            <col width="100" />
                          </colgroup>
                          <thead className="grids_header">
                            <tr>
                              <th colSpan="2" className="text-center">
                                {translate("Additional info")}
                              </th>
                              <th className="text-center">
                                {translate("Status")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.stagesList(
                              this.state.report.components,
                              this.state.report.pipelineInstanceId
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <div>
                <Button
                  color="primary"
                  style={{ margin: 0 }}
                  disabled={
                    this.state.loading ||
                    (this.state.showPeriod &&
                      (!this.state.periodStart || !this.state.periodEnd)) ||
                    (this.state.showFile && !this.state.fileIdValid) ||
                    (this.state.showFinalizedChannel && !this.state.channel) ||
                    (this.state.showBatchID && !this.state.batchId)
                  }
                  onClick={this.handleRunReportClick}
                >
                  {translate("Run report")}
                </Button>
                {this.state.loading && (
                  <img
                    alt=""
                    style={{ padding: "12px 12px" }}
                    src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                  />
                )}
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { config, locale, authentication, settings } = state;
  const { user, subUser, isSubUser } = authentication;
  return {
    config,
    settings,
    user,
    subUser,
    isSubUser,
    translate: getTranslate(locale),
  };
}

const connectedRunTestReport = connect(mapStateToProps)(
  withRouter(RunTestReport)
);
export { connectedRunTestReport as RunTestReport };
